import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { WizardService } from 'src/app/services/wizard/wizard.service';
import { ContinueButtonComponent } from '../continue-button/continue-button.component';
import { WizardOption } from 'src/app/models/wizard/wizard-option';
import { WizardStepName } from 'src/app/services/wizard/wizard-step-name.enum';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-wizard-navigation',
  templateUrl: './wizard-navigation.component.html',
  styleUrls: ['./wizard-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizardNavigationComponent implements OnInit {
  @Input() hideBackButton: boolean = false;
  @Input() disableContinueButton: boolean = false;
  @Input() previousStepRoute: string = "";
  @Input() nextStepRoute: string = "";
  @Input() isStartStep: boolean = false;
  @Input() currentStepName: string = "";
  @Input() currentStepNumber: number = 0;
  @Input() wizardOption: WizardOption = new WizardOption();
  @Input() hasSkipButton: boolean = true;

  @Output() onSkipPressed: EventEmitter<any> = new EventEmitter();

  
  @ViewChild(ContinueButtonComponent)
  continueButtonComponent!: ContinueButtonComponent


  totalSteps: number = 0;

  constructor(private wizardService: WizardService) { }

  ngOnInit(): void {
    this.totalSteps = this.wizardService.getTotalStepCount();       
  }

  getPreviousStepNumber(): number {
    return this.currentStepNumber - 1;
  }

  getNextStepNumber(): number {
    return this.currentStepNumber + 1;
  }


  programaticallyClickContinue(): void {
    this.continueButtonComponent.continueBtnClickEvent()
  }  

  onSkip(): void {
    this.onSkipPressed.emit()
    this.programaticallyClickContinue();
  }
}
